import config from '../setup/config';
import ScriptLoader from './script-loader';
import i18n from '../setup/locale';
import router from '../setup/router';
import store from '../store/store';

export default class MicrofrontendLoader {
  static routeMap = [
    {
      key: 'dashboardui', path: 'Dashboard', feature: 'DashboardUI',
    },
    {
      key: 'campaignsui', subkey: 'campaigns', path: 'Campaigns', feature: 'CampaignsUI',
    },
    {
      key: 'campaignsui', subkey: 'audiences', path: 'Audiences', feature: 'AudienceUI',
    },
    { key: 'experienceui', path: 'Experiences' },
    {
      key: 'eventtrackingui', path: 'Tracking', feature: 'EventTrack',
    },
    {
      key: 'reportdashboardui', path: 'Reporting', feature: 'ReportDash',
    },
    {
      key: 'reportingui', path: 'Reporting', feature: 'PIReports',
    },
    {
      key: 'usermanagementui', subkey: 'profile', path: 'Profile', feature: 'ProfileUI',
    },
    {
      key: 'usermanagementui', subkey: 'users', path: 'Users', feature: 'UserManagementUI',
    },
    {
      key: 'integrationsui', path: 'Integrations', feature: 'IntegrationsUI',
    },
  ];

  static async load(to) {
    const segment = to.path.split('/')[1];
    const entry = MicrofrontendLoader.routeMap
      .find((x) => x.path === segment && store.getters.hasClientFeature(x.feature));
    const key = entry && entry.key;

    if (!key) return undefined;
    if (window.microfrontends[key]) return undefined;

    const url = config.microfrontends[key];
    await ScriptLoader.load(`${url}/css/main.css`);
    await ScriptLoader.load(`${url}/js/main.js`);

    const {
      dependencies,
      routes,
      locales,
      module,
    } = window.microfrontends[key];

    const mappings = MicrofrontendLoader.routeMap.filter((x) => x.key === entry.key);

    await MicrofrontendLoader.loadDependencies(dependencies);
    MicrofrontendLoader.loadRoutes(mappings, routes);
    MicrofrontendLoader.loadLocales(locales, key);
    MicrofrontendLoader.loadModule(module, key);

    return to.fullPath;
  }

  static async loadDependencies(dependencies) {
    if (!dependencies) return;
    await dependencies();
  }

  static loadRoutes(mappings, routeConfig) {
    const loadedRoutes = [];

    if (mappings.length === 1) {
      loadedRoutes.push({
        path: mappings[0].path,
        component: { render: (c) => c('router-view') },
        children: routeConfig,
      });
    } else {
      loadedRoutes.push(...mappings.map((mapping) => ({
        path: mapping.path,
        component: { render: (c) => c('router-view') },
        children: routeConfig[mapping.subkey],
      })));
    }

    const newRoutes = router.options.routes;
    const rootPath = newRoutes.find((x) => x.path === '/');
    rootPath.children = [...loadedRoutes, ...rootPath.children];
    router.addRoutes(newRoutes);
  }

  static loadModule(module, key) {
    if (!module) return;

    store.registerModule(key, module);
  }

  static loadLocales(locales, key) {
    if (!locales) return;

    Object.keys(locales).forEach(
      (x) => i18n.setLocaleMessage(x, {
        ...i18n.messages[x],
        [key]: locales[x],
      }),
    );
  }
}
